exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-09aab3fc] .el-table__header-wrapper .el-table__header .el-checkbox{display:none}", ""]);

// exports
